import classes from './login-container.module.scss';

import { CcfBox, CcfCxoneLogoIcon, CcfTypography } from '@nice-ccf/ui-controls';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import AWS from 'aws-sdk';
import LoginStageOne from '../login-stage-one/login-stage-one';
import LoginStageTwo from '../login-stage-two/login-stage-two';
import Footer from '../footer/footer';

import {
  loginActions,
  selectLoginCredentialsState,
  selectLoginScreenState,
  selectLoginErrorState,
  getLoggedInUser,
} from '../+state/login.slice';
// import { s3Config } from '../../../../../../../apps/cxone-agent-demo/src/environments/environment';

import { Box, Grid, Hidden } from '@mui/material';
import { MarketingPanel } from '@nice-ccf/ui-components';
import { useEffect, useState } from 'react';
//import AWS from 'aws-sdk';

/* eslint-disable-next-line */
export interface LoginContainerProps {}

/**
 * Container component used for login
 * @param props - LoginContainerProps
 * @example <LoginContainer />
 * @returns
 */
export function LoginContainer(props: LoginContainerProps) {
  const dispatch = useDispatch();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const [isTablet, setIsTablet] = useState(
    window.innerWidth > 600 && window.innerWidth <= 1024
  );
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
      setIsTablet(window.innerWidth > 600 && window.innerWidth <= 1024);
      setIsDesktop(window.innerWidth > 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const credentials = useSelector(selectLoginCredentialsState);
  const screen = useSelector(selectLoginScreenState);
  const error = useSelector(selectLoginErrorState);
  //let allUsers :any = [];
  //const s3 = new AWS.S3({accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID, secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY, region: process.env.REACT_APP_AWS_REGION});
  const {
    setUsername,
    setPassword,
    navigateToUsernameScreen,
    setS3RegisterdUsers,
    checkUserNameAndNavigate,
    checkUserNameAndPassword,
  } = loginActions;

  const s3Config = {
    accessKeyId: 'AKIAVFMUJ6SX7NP6G5FY',
    secretAccessKey: '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',
    s3Bucket:
      window.location.hostname === 'd1u959wi0vug3n.cloudfront.net'
        ? 'cxone-agent-html-demo-phase2'
        : 'cxone-agent-demo-app',
    region: 'us-west-2',
  };

  const S3_BUCKET = s3Config.s3Bucket;
  const OBJECT_KEY = 'userDB/Users.json';
  AWS.config.update({
    accessKeyId: s3Config.accessKeyId,
    secretAccessKey: s3Config.secretAccessKey,
    region: s3Config.region,
  });

  const s3 = new AWS.S3();

  /**
   * @param panel- 'contacthistory'
   * @param event - changeevent
   * @param newExpanded - boolean
   * @example - fetchObjectFromS3(panel)
   */ const fetchS3Object = async () => {
    const params = {
      Bucket: S3_BUCKET,
      Key: OBJECT_KEY,
    };

    try {
      const data = await s3.getObject(params).promise();
      const d = JSON.parse(JSON.stringify(data.Body?.toString('utf-8')));
      const userJson = JSON.parse(d);

      dispatch(setS3RegisterdUsers(userJson));
    } catch (error) {
      console.log('error', error);
    }
  };

  /**
   * Function to get user details from S3
   * @returns
   * @example - getLoggedInUserDetailsFromS3()
   */
  // const getLoggedInUserDetailsFromS3 = async () => {

  //   const bucketName = s3.bucket.name;
  //   const objectKey = s3.object.key;

  //   try {
  //       const data = await s3.getObject({ Bucket: bucketName, Key: objectKey }).promise();
  //       const fileContent = data.Body.toString('utf-8');
  //       console.log(JSON.parse(fileContent));
  //       // Process the file content as needed
  //       allUsers = JSON.parse(fileContent);
  //   } catch (error) {
  //       console.error('Error reading S3 object:', error);
  //   }

  // }

  /**
   * Function to handle user name change
   * @param e - React.ChangeEvent<HTMLInputElement>
   * @example - onUserNameChange(e)
   */
  const onUserNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setUsername(e.target.value));
  };

  /**
   * Function to handle password change
   * @param e - React.ChangeEvent<HTMLInputElement>
   * @example - onPasswordChange(e)
   */
  const onPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setPassword(e.target.value));
  };

  /**
   * function to handle user name submit
   * @param e -React.SyntheticEvent
   * @example - handleUsernameSubmit(e)
   */
  const handleUsernameSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    await fetchS3Object();
    await dispatch(checkUserNameAndNavigate(credentials.username));
  };

  /**
   * function to handle password submit
   * @param e -React.SyntheticEvent
   * @example - handlePasswordSubmit(e)
   */
  const handlePasswordSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    dispatch(checkUserNameAndPassword(credentials));
    localStorage.setItem('credentials', JSON.stringify(credentials));
    localStorage.removeItem('contactHistoryLS'); //Remove contact history from local storgae after login
    localStorage.removeItem('interactionHistoryLS'); //Remove interactions history from local storgae after login
  };

  /**
   * function used to navigate back to username screen
   * @example -handlePasswordScreenBackAction()
   */
  const handlePasswordScreenBackAction = () => {
    dispatch(navigateToUsernameScreen());
  };

  /**
   * Function to render screen as per input
   * @param param - string
   * @example renderScreen('voicepreferencesscreen)
   * @returns
   */
  const renderScreen = (param: string) => {
    switch (param) {
      case 'usernamelogin':
        return (
          <LoginStageOne
            onUserNameChange={onUserNameChange}
            checkUserNameAndNavigate={handleUsernameSubmit}
            error={error}
            currentusername={credentials.username}
          />
        );
      case 'passwordlogin':
        return (
          <LoginStageTwo
            navigateToUsernameLoginScreen={handlePasswordScreenBackAction}
            checkUserNameAndPassword={handlePasswordSubmit}
            currentusername={credentials.username}
            currentpassword={credentials.password}
            error={error}
            onPasswordChange={onPasswordChange}
          />
        );
      default:
        return <CcfTypography variant="h6">Loading...</CcfTypography>;
    }
  };

  return (
    <Grid container>
      <Grid item lg={isDesktop ? 8 : 12} md={12} xs={12} sm={12}>
        <CcfBox className={classes.loginContainer}>
          <CcfBox>
            <CcfCxoneLogoIcon
              style={{
                fill: '#ffff',
                width: '150px',
                height: '70px',
              }}
            />
          </CcfBox>
          {renderScreen(screen.name)}

          <Footer />
        </CcfBox>
      </Grid>

      {isDesktop && (
        <Grid
          item
          lg={4}
          // display={{ xs: 'none', sm: 'none', md: 'none', lg: 'block' }}
        >
          <MarketingPanel />
        </Grid>
      )}
    </Grid>
  );
}

export default LoginContainer;
